<div class=color-wrapper>
  <app-color-palette [hue]="hue" (color)="color=$event" (click)="userSelect(color)"></app-color-palette>
  <app-color-slider class="color-slider-margin" (color)="hue=$event"></app-color-slider>
</div>
<div class="input-wrapper">
  <!-- <span class="text">{{hex}}</span> -->
  <div class="color-div" [ngStyle]="{'background-color': color || 'white'}"></div>
</div>
<div class="input-wrapper2">
  <span class="text">Quick Select</span>
  <div *ngFor="let item of selected" class="color-div-new cursor-pointer" (click)="selectColor(item)"
    [ngStyle]="{'background-color': item}"></div>
</div>